import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ICopyLinkedCheckBehavior } from "../../../../documaker/domain/format/objects";

export interface ICopyLinkedCheckBehaviorPropertyEditable {
  copyLinkedCheckBehavior(): IPropertyEditable<ICopyLinkedCheckBehavior>;
}

export function instanceOfICopyLinkedCheckBehaviorPropertyEditable(instance: any): instance is ICopyLinkedCheckBehaviorPropertyEditable {
  return instance
      && instance.copyLinkedCheckBehavior
      && instanceOfIPropertyEditable<ICopyLinkedCheckBehavior>(instance.copyLinkedCheckBehavior());
}
